

<div class="loader"  [hidden]="status != LOADING">
    <div class="dimmed dimmed_list_checks">
        <div class="dimmed_flex">
            <div class="dimmed_box_small"></div>
            <div class="dimmed_title"></div>
        </div>
         <div class="dimmed_flex">
                <div class="dimmed_box_small"></div>
                <div class="dimmed_title"></div>
        </div>
        <div class="dimmed_flex">
            <div class="dimmed_box_small"></div>
            <div class="dimmed_title"></div>
        </div>
    </div>
</div>

<div *ngIf="status == DONE && files.length > 0" class="file-list-checkbox">
    <header class="counter-header">
        <h5 [hidden]="!counter">
            <em>{{files.length}}</em>
            <span [hidden]="files.length > 1">{{counterSingularTitle}}</span>
            <span [hidden]="files.length < 2">{{counterPluralTitle}}</span>
            <core-helpers-icons-blue-circle [hidden]="!checked"></core-helpers-icons-blue-circle>
        </h5>
    </header>

    <core-files-list-checkbox
      [files]="files"
      [selected]="selected"
      (selectedChange)="onChange($event)"
      [disabled]="disabled"
    ></core-files-list-checkbox>

</div>
